import React from 'react';
import { Link } from 'react-router-dom';

export function LayoffTrackerSection() {
  const layoffs = [
    { company: 'Company 1', date: 'January 2, 2025' },
    { company: 'Company 2', date: 'January 5, 2025' },
    { company: 'Company 3', date: 'January 10, 2025' },
    { company: 'Company 4', date: 'February 21, 2025' },
    { company: 'Company 5', date: 'February 28, 2025' },
    { company: 'Company 6', date: 'March 15, 2025' },
    { company: 'Company 7', date: 'March 15, 2025' },
    { company: 'Company 8', date: 'May 1, 2025' },
    { company: 'Company 9', date: 'May 10, 2025' },
    { company: 'Company 10', date: 'September 19, 2025' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://i.ibb.co/hWZcm12/7.png" 
              alt="we track company layoffs" 
              className="w-auto h-auto max-h-48 mb-6 sm:mb-8"
              style={{ objectFit: 'contain' }}
            />
            <Link 
              to="/admin/layoffs"
              className="inline-block px-8 py-3 bg-[#800020] text-white rounded-full hover:opacity-90 transition-opacity text-xl"
              style={{ fontFamily: 'Noto Serif Ethiopic Condensed' }}
            >
              View Live Tracker
            </Link>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="grid grid-cols-2 gap-4">
              <div className="font-bold text-[#800020] border-b-2 border-[#800020] pb-2">Company</div>
              <div className="font-bold text-[#800020] border-b-2 border-[#800020] pb-2">Layoff Date</div>
              {layoffs.map((layoff, index) => (
                <React.Fragment key={index}>
                  <div className="text-[#800020] py-2">{layoff.company}</div>
                  <div className="text-[#800020] py-2">{layoff.date}</div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}